// extracted by mini-css-extract-plugin
export default {"container":"xm-z","bubbleNav":"ym-z","graphic":"zm-z","contact":"Am-z"};